import { NavNode } from './types';

const navItems: NavNode[] = [
  {
    id: 'bill-meter',
    title: 'RISK METERS',
    icon: 'stats-growth',
    tooltip: false,
  },
  {
    id: 'worldwide-attacks', // this must also be the path
    title: 'WORLDWIDE ATTACKS - LIVE',
    icon: 'world-net',
    tooltip: true,
    tooltipText: 'Rolling 24-hour attack statistics updated every minute',
  },
  {
    id: 'capture-labs-threat-metrics',
    title: 'CAPTURE LABS THREAT METRICS',
    icon: 'monitoring',
    tooltip: false,
  },
  {
    id: 'security-news',
    title: 'SECURITY NEWS',
    icon: 'security-services',
    tooltip: false,
  },
];

export default navItems;
